import { render, staticRenderFns } from "./ToolArea.vue?vue&type=template&id=b90a41b6&scoped=true"
import script from "./ToolArea.vue?vue&type=script&lang=js"
export * from "./ToolArea.vue?vue&type=script&lang=js"
import style0 from "./ToolArea.vue?vue&type=style&index=0&id=b90a41b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90a41b6",
  null
  
)

export default component.exports